import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";

import SuccessPage from "../../../components/pages/SuccessPage";

export const Route = createFileRoute("/tracker/$trackerId/success")({
    component: TrackerSuccessPage,
});

function TrackerSuccessPage() {
    return (
        <SuccessPage
            title="Success, form submitted!"
            description="Your responses have been saved."
            icon={CheckCircle2}
            primaryButton={{ text: "Next", to: "/" }}
        />
    );
}
